import React, { Component, Fragment } from 'react';
import './Plannables.module.scss';
import { connect } from 'react-redux';
import { Droppable } from 'react-beautiful-dnd';

//Import components
import PlannableItem from 'components/UI/Popup/Plannables/PlannableItem/PlannableItem.jsx';

//Import selectors
import getTasksThatNeedPlanning from 'selectors/task/task-need-planning';

const mapStateToProps = (state, props) => {
    return {
        tasks: getTasksThatNeedPlanning(state, props)
    };
};

class Plannables extends Component {
    constructor() {
        super();

        this.state = {
            showGif: false
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.tasks && prevProps.tasks.length == 1 && this.props.tasks && this.props.tasks.length == 0) {
            this.setState({showGif: true});
            setTimeout(() => this.setState({showGif: false}), 3000);
        }
    }

    render() {

        const {tasks, visible} = this.props;

        return visible ? (
            
            <Droppable droppableId={'plannablesDroppable'}>
                {(provided ) => (
                    <div styleName="plannables-background" ref={provided.innerRef}
                        {...provided.droppableProps} >
                        <div styleName="front">
                            {
                                tasks.length > 0 &&
                                <PlannableItem index={0} task={tasks[0]}/>
                            }
                        </div>
                        <div styleName="back">
                            {
                                tasks.length > 1 &&
                                <PlannableItem style={{width: '150px', marginRight: '22px'}} index={1} task={tasks[1]}/>
                            }
                        </div>
                        {
                            this.state.showGif &&
                            <img styleName='gif' src='/images/gif/all_tasks_planned.gif' />
                        }
                        {
                            provided.placeholder
                        }
                    </div>
                )}
            </Droppable>
        ) : '';
    }
}

export default connect(mapStateToProps, null)(Plannables);